import { action, observable } from 'mobx'
import { MessagesRequest } from '../requests/MessagesRequest'

class MessagesStore {
  messageList = []
  messageDetail = {}
  messageTotalCount = 0
  unreadMessageCount = 0
  replyMessages = []
  pageSize = 30
  pageIndex = 0

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }
  getList = () => {
    return new Promise((resolve, reject) => {
      MessagesRequest.getList(this.pageIndex, this.pageSize)
        .then(response => {
          this.messageList = [...this.messageList, ...response.data.data]
          this.messageTotalCount = response.data.totalElements
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getMessageCreated = () => {
    return new Promise((resolve, reject) => {
      MessagesRequest.getList(0, 1)
        .then(response => {
          this.messageList = [...response.data.data, ...this.messageList]
          this.messageTotalCount = response.data.totalElements
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getMessageById = id => {
    return new Promise((resolve, reject) => {
      MessagesRequest.getMessageById(id)
        .then(response => {
          this.messageDetail = response.data
          this.replyMessages = response.data.replyMessages
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  create = data => {
    return new Promise((resolve, reject) => {
      MessagesRequest.create(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Clear */
  clearMessageStore = () => {
    this.messageList.length = 0
    this.messageTotalCount = 0
    this.replyMessages = []
    this.unreadMessageCount = 0
    this.messageDetail = {}
    this.pageIndex = 0
    this.pageSize = 30
  }
}

export default new MessagesStore()
